export default function A11yAutofocus(node) {
  this.node = node
  this.node.focus()
}
